<template>
  <div>
    <b-modal
      id="professioncategoryCreateModal"
      title="Skrá starfsgreinaflokk"
      size="lg"
      lazy
      :no-close-on-backdrop="true"
      ok-title="Vista"
      cancel-title="Hætta við"
      @ok.prevent="handleCreate"
      :ok-disabled="loading"
      ref="createModal"
    >
      <profession-category-create-form
        ref="professionCategoryCreateForm"
        @successful="successful"
        @loading="setLoading"
      ></profession-category-create-form>
    </b-modal>
  </div>
</template>

<script>
import ProfessionCategoryCreateForm from '@/components/professioncategory/ProfessionCategoryCreateForm.vue';

export default {
  name: 'profession-category-crud-modal',
  components: {
    ProfessionCategoryCreateForm,
  },
  data() {
    return {
      id: null,
      loading: false,
    };
  },
  methods: {
    show(id = null) {
      this.id = id;
      this.$refs.createModal.show();
    },
    handleCreate() {
      this.$refs.professionCategoryCreateForm.validateBeforeSubmit();
    },
    successful(data) {
      this.$emit('successful', data);
      this.$refs.createModal.hide();
    },
    setLoading(value) {
      this.loading = value;
    },
  },
};
</script>
